import { useNavigate } from 'react-router-dom';
import MyModal from '../../../../components/Modal';
import { IAsksGoToExistingResultModalData } from '../types';

export default function AsksGoToExistingResultModal({
  asksGoToExistingResultModalData,
  setAsksGoToExistingResultModalData,
}: {
  asksGoToExistingResultModalData: IAsksGoToExistingResultModalData;
  setAsksGoToExistingResultModalData: React.Dispatch<React.SetStateAction<IAsksGoToExistingResultModalData>>;
}) {
  const navigate = useNavigate();

  return (
    <MyModal
      show={asksGoToExistingResultModalData.show}
      onClose={() => setAsksGoToExistingResultModalData((prev) => ({ ...prev, show: false }))}
      title={'Já existe um resultado para este funcionário'}
      centeredBody
      modalBody={(
        <>
            Você deseja visualizar o resultado que já foi gerado para este funcionário, ou fazer uma nova roteirização para o mesmo?
        </>
      )}
      closeButtonLabel="Prosseguir com nova roteirização"
      size="lg"
      type='action'
      actionButtonLabel='Visualizar resultado já existente'
      onAction={() => {
        navigate(asksGoToExistingResultModalData.link);
      }}
    />
  );
}
